import { htmlSafe } from '@ember/template';
import type { TOC } from '@ember/component/template-only';

export interface TioFaqsSignature {
  Args: {
    // Seems weird that these are optional, but tons of code assumes they are
    question?: string;
    answer?: string;
  };
  Element: HTMLDivElement;
}

const TioFaqs: TOC<TioFaqsSignature> = <template>
  <div ...attributes>
    <h3 class="font-semibold">
      {{if @question (htmlSafe @question)}}
    </h3>
    <p class="mt-1 text-sm tio-fg-muted">
      {{#if @answer}}
        {{htmlSafe @answer}}
      {{/if}}
    </p>
  </div>
</template>;

export default TioFaqs;
